// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-widget {
  aspect-ratio: 1;
  position: relative;
  max-height: 225px;
  min-height: 225px;
}
.location-widget .menu-button {
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.location-widget .menu-button ion-icon {
  font-size: 18px;
  color: #666;
}
.location-widget .location-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}
.location-widget .location-container .map-container {
  flex: 1;
  height: 100%;
  border-radius: 8px;
}
.location-widget .location-container .map-container iframe {
  border-radius: 8px;
  width: 100%;
}
.location-widget .no-location-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 5px;
}
.location-widget .no-location-container .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.location-widget .no-location-container .loading-container ion-spinner {
  --color: #ed143d;
  width: 24px;
  height: 24px;
}
.location-widget .no-location-container .loading-container span {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  line-height: 1.4;
}
.location-widget .no-location-container .permission-denied,
.location-widget .no-location-container .request-permission {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.location-widget .no-location-container .permission-denied ion-icon,
.location-widget .no-location-container .request-permission ion-icon {
  font-size: 32px;
  color: #ed143d;
}
.location-widget .no-location-container .permission-denied span,
.location-widget .no-location-container .request-permission span {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  line-height: 1.4;
}
.location-widget .no-location-container .permission-denied ion-button,
.location-widget .no-location-container .request-permission ion-button {
  --color: #ed143d;
  --background: transparent;
  font-size: 12px;
  height: 32px;
  margin-top: 8px;
}

.location-menu-popover {
  --width: 200px;
}
.location-menu-popover ion-list {
  padding: 0;
  font-weight: 600;
}
.location-menu-popover div {
  display: flex;
  align-items: center;
  padding: 10px 5px;
  gap: 5px;
  cursor: pointer;
}
.location-menu-popover div ion-icon {
  font-size: 18px;
  color: #666;
}
.location-menu-popover div ion-label {
  font-size: 14px;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/location-widget/location-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAEJ;AADI;EACE,eAAA;EACA,WAAA;AAGN;AAAE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAEJ;AAAI;EACE,OAAA;EACA,YAAA;EACA,kBAAA;AAEN;AAAM;EACE,kBAAA;EACA,WAAA;AAER;AAGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AADJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADN;AAGM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AADR;AAIM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAFR;AAMI;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAJN;AAMM;;EACE,eAAA;EACA,cAAA;AAHR;AAMM;;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAHR;AAMM;;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAHR;;AASA;EACE,cAAA;AANF;AAQE;EACE,UAAA;EACA,gBAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,eAAA;AAPJ;AAQI;EACE,eAAA;EACA,WAAA;AANN;AASI;EACE,eAAA;EACA,WAAA;AAPN","sourcesContent":[".location-widget {\n  aspect-ratio: 1;\n  position: relative;\n  max-height: 225px;\n  min-height: 225px;\n  .menu-button {\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    ion-icon {\n      font-size: 18px;\n      color: #666;\n    }\n  }\n  .location-container {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    position: relative;\n\n    .map-container {\n      flex: 1;\n      height: 100%;\n      border-radius: 8px;\n\n      iframe {\n        border-radius: 8px;\n        width: 100%;\n      }\n    }\n  }\n\n  .no-location-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    text-align: center;\n    padding: 5px;\n\n    .loading-container {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 12px;\n\n      ion-spinner {\n        --color: #ed143d;\n        width: 24px;\n        height: 24px;\n      }\n\n      span {\n        font-size: 12px;\n        color: #666;\n        font-weight: 500;\n        line-height: 1.4;\n      }\n    }\n\n    .permission-denied,\n    .request-permission {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 12px;\n\n      ion-icon {\n        font-size: 32px;\n        color: #ed143d;\n      }\n\n      span {\n        font-size: 12px;\n        color: #666;\n        font-weight: 500;\n        line-height: 1.4;\n      }\n\n      ion-button {\n        --color: #ed143d;\n        --background: transparent;\n        font-size: 12px;\n        height: 32px;\n        margin-top: 8px;\n      }\n    }\n  }\n}\n\n.location-menu-popover {\n  --width: 200px;\n\n  ion-list {\n    padding: 0;\n    font-weight: 600;\n  }\n\n  div {\n    display: flex;\n    align-items: center;\n    padding: 10px 5px;\n    gap: 5px;\n    cursor: pointer;\n    ion-icon {\n      font-size: 18px;\n      color: #666;\n    }\n\n    ion-label {\n      font-size: 14px;\n      color: #333;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
